"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var enquiryFormTitleStyles = makeStyles_1.default(function (_a) {
    var _b;
    var typography = _a.typography, breakpoints = _a.breakpoints, spacing = _a.spacing;
    return ({
        title: (_b = {
                textAlign: 'center',
                marginLeft: 'inherit',
                fontFamily: typography.fontFamily2,
                margin: spacing(2) + " 0 " + spacing(3.5)
            },
            _b[breakpoints.down('sm')] = {
                padding: "0 " + spacing(1),
            },
            _b),
    });
}, { name: 'Checkout_EnquiryFormTitle' });
exports.default = enquiryFormTitleStyles;
